import React from 'react';
import { AnimatedClasses } from '../../utils/animatedStyles';
import { useCloseModal } from './hooks/useCloseModal';
import * as Styles from './styles';

interface Props {
  text: string;
  closeHandler: () => void;
}

export const SimpleModal: React.FC<Props> = ({ closeHandler, text }) => {
  const { refInnWrapper, closeModal } = useCloseModal(closeHandler);

  return (
    <>
      <Styles.ModalOuterWrapperS>
        <Styles.ModalInnerWrapperS style={{ maxWidth: '750px' }} ref={refInnWrapper} className={AnimatedClasses.zoomIn}>
          <div style={{ padding: '5px', textAlign: 'right' }}>
            <i style={{ cursor: 'pointer', fontSize: '25px' }} className="bi bi-x" onClick={closeModal} />
          </div>
          <Styles.ModalBodyS>
            <h4>{text}</h4>
          </Styles.ModalBodyS>
        </Styles.ModalInnerWrapperS>
      </Styles.ModalOuterWrapperS>
    </>
  );
};
